import clsx from 'clsx'
import Content, { textColors, textSizes } from '../elements/Content'
import { PageInfo } from '@/src/@types/models'
import { BardText as BardTextType } from '@/src/@types/statamic'

const isEmpty = (text?: string) =>
  !text?.replace(/<\/?p>|<br\s*\/?>|&nbsp;|\s/g, '')

export default function BardText({
  text,
  fullWidth,
  textSize,
  textColor,
  sidebar,
  pageInfo,
}: BardTextType & {
  fullWidth?: boolean
  textSize?: keyof typeof textSizes
  textColor?: keyof typeof textColors
  sidebar?: boolean
  pageInfo?: PageInfo
}) {
  if (isEmpty(text)) return null

  return (
    <div>
      <Content
        content={text}
        className={clsx([
          {
            'md:max-w-[33.333%]': sidebar,
            'max-w-full lg:max-w-full': fullWidth,
            'max-w-full lg:max-w-[66.667%]': !fullWidth,
          },
        ])}
        textSize={textSize}
        textColor={textColor}
        pageInfo={pageInfo}
      />
    </div>
  )
}
